/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyIdRequest
 */
export interface EmergencyIdRequest {
    /**
     * 
     * @type {string}
     * @memberof EmergencyIdRequest
     */
    emergency_id: string;
}

/**
 * Check if a given object implements the EmergencyIdRequest interface.
 */
export function instanceOfEmergencyIdRequest(value: object): value is EmergencyIdRequest {
    if (!('emergency_id' in value) || value['emergency_id'] === undefined) return false;
    return true;
}

export function EmergencyIdRequestFromJSON(json: any): EmergencyIdRequest {
    return EmergencyIdRequestFromJSONTyped(json, false);
}

export function EmergencyIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency_id': json['emergency_id'],
    };
}

export function EmergencyIdRequestToJSON(json: any): EmergencyIdRequest {
    return EmergencyIdRequestToJSONTyped(json, false);
}

export function EmergencyIdRequestToJSONTyped(value?: EmergencyIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency_id': value['emergency_id'],
    };
}

